import axios from "axios";
import { takeLatest, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../../utils/queryParams.js";

export const SET_LOADING = "saga/SET_LOADING";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CLIENT_INFO_SUCCESS = "saga/FETCH_CLIENT_INFO_SUCCESS";
export const FETCH_CLIENT_VISITS_SUCCESS = "saga/FETCH_CLIENT_VISITS_SUCCESS";
export const FETCH_CLIENT_SALES_SUCCESS = "saga/FETCH_CLIENT_SALES_SUCCESS";
export const FETCH_CLIENT_PAST_DUES_SUCCESS = "saga/FETCH_CLIENT_PAST_DUES_SUCCESS";
export const FETCH_CLIENT_MEMBERSHIP_TYPES_SUCCESS = "saga/FETCH_CLIENT_MEMBERSHIP_TYPES_SUCCESS";
export const FETCH_CLIENT_PROSPECT_TYPES_SUCCESS = "saga/FETCH_CLIENT_PROSPECT_TYPES_SUCCESS";
export const FETCH_CLIENT_CONTRACTS_SUCCESS = "saga/FETCH_CLIENT_CONTRACTS_SUCCESS";
export const FETCH_CONTRACTS_STATUSES_SUCCESS = "saga/FETCH_CONTRACTS_STATUSES_SUCCESS";
export const FETCH_CONTRACTS_FREEZES_SUCCESS = "saga/FETCH_CONTRACTS_FREEZES_SUCCESS";
export const FETCH_CLIENT_CONTACT_LOGS_SUCCESS = "saga/FETCH_CLIENT_CONTACT_LOGS_SUCCESS";
export const FETCH_CLIENT_CHARTS_SUCCESS = "saga/FETCH_CLIENT_CHARTS_SUCCESS";
export const FETCH_DATA_ERROR = "saga/FETCH_DATA_ERROR";
export const SEND_CONTACT_LOG_REQUEST = "saga/SEND_CONTACT_LOG_REQUEST";
export const SEND_CONTACT_LOG_REQUEST_SUCCESS = "saga/SEND_CONTACT_LOG_REQUEST_SUCCESS";
export const SET_CLIENT_LOGS_LOADING = "sagas/SET_CLIENT_LOGS_LOADING";
export const SET_API_ERROR = "sagas/SET_API_ERROR";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  sendContactLogRequest: createAction(SEND_CONTACT_LOG_REQUEST)
};
export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
}

let date;

export function* getCurrentUserData(data) {
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: data.payload });
  yield put({ type: SET_LOADING, payload: true });

  const newdate = new Date();
  const m = newdate.getMonth() + 1;
  const y = newdate.getFullYear();
  const d = newdate.getDate();
  const currentDate = y + "-" + m + "-" + d;

  date = currentDate;

  const id = yield select((state) => state.clientProfileModule.currentUser.organization_id);
  const objectId = yield select((state) => state.clientProfileModule.currentUser.current_object_id);
  const locationId = yield select(
    (state) => state.clientProfileModule.currentUser.current_location_id
  );
  const regionId = yield select((state) => state.clientProfileModule.currentUser.current_region_id);
  const clientUid = yield select((state) => state.clientProfileModule.currentUser.client_uid);
  const isAdmin = yield select((state) => state.clientProfileModule.currentUser.isAdmin);
  const allSagas = [
    getClientSales(id, objectId, locationId, regionId, clientUid, date),
    getClientInfo(id, objectId, locationId, regionId, clientUid, date),
    getClientVisits(id, objectId, locationId, regionId, clientUid, date),
    getClientCharts(id, objectId, locationId, regionId, clientUid, date),
    getClientPastDues(id, objectId, locationId, regionId, clientUid, date),
    getClientMembershipTypes(id, objectId, locationId, regionId, clientUid, date),
    getClientProspectTypes(id, objectId, locationId, regionId, clientUid, date)
  ];
  if (isAdmin) {
    allSagas.push(getClientContracts(id, objectId, locationId, regionId, clientUid, date));
    allSagas.push(getContractStatuses(id, objectId, locationId, regionId, clientUid, date));
    allSagas.push(getContractFreezes(id, objectId, locationId, regionId, clientUid, date));
  }

  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_DATA_ERROR, payload: error });
    console.log("error getting data");
  }
  try {
    yield all([getClientContactLogs(id, objectId, locationId, regionId, clientUid, date)]);
    yield put({ type: SET_CLIENT_LOGS_LOADING, payload: false });
  } catch (error) {
    console.log("error getting data");
  }
}

export function* getClientInfo(id, objectId, locationId, regionId, clientUid, date) {
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "clients/info" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date +
        "" +
        "&client_uid=" +
        clientUid
    );
    if (typeof response.data === "string") {
      yield put({ type: SET_API_ERROR, payload: true });
    }
    yield put({ type: FETCH_CLIENT_INFO_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_DATA_ERROR, payload: error });
  }
}

export function* getClientVisits(id, objectId, locationId, regionId, clientUid, date) {
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "clients/visits" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date +
        "" +
        "&client_uid=" +
        clientUid
    );

    if (typeof response.data === "string") {
      yield put({ type: SET_API_ERROR, payload: true });
    }
    yield put({ type: FETCH_CLIENT_VISITS_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_DATA_ERROR, payload: error });
  }
}

export function* getClientSales(id, objectId, locationId, regionId, clientUid, date) {
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "clients/sales" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date +
        "" +
        "&client_uid=" +
        clientUid
    );
    if (typeof response.data === "string") {
      yield put({ type: SET_API_ERROR, payload: true });
    }
    yield put({ type: FETCH_CLIENT_SALES_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_DATA_ERROR, payload: error });
  }
}

export function* getClientPastDues(id, objectId, locationId, regionId, clientUid, date) {
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "clients/past_dues" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date +
        "" +
        "&client_uid=" +
        clientUid
    );
    if (typeof response.data === "string") {
      yield put({ type: SET_API_ERROR, payload: true });
    }
    yield put({ type: FETCH_CLIENT_PAST_DUES_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_DATA_ERROR, payload: error });
  }
}

export function* getClientMembershipTypes(id, objectId, locationId, regionId, clientUid, date) {
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "clients/membership_types" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date +
        "" +
        "&client_uid=" +
        clientUid
    );
    if (typeof response.data === "string") {
      yield put({ type: SET_API_ERROR, payload: true });
    }
    yield put({ type: FETCH_CLIENT_MEMBERSHIP_TYPES_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_DATA_ERROR, payload: error });
  }
}
export function* getClientProspectTypes(id, objectId, locationId, regionId, clientUid, date) {
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "clients/prospect_types" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date +
        "" +
        "&client_uid=" +
        clientUid
    );
    if (typeof response.data === "string") {
      yield put({ type: SET_API_ERROR, payload: true });
    }
    yield put({ type: FETCH_CLIENT_PROSPECT_TYPES_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_DATA_ERROR, payload: error });
  }
}

export function* getClientContracts(id, objectId, locationId, regionId, clientUid, date) {
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "clients/contracts" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date +
        "" +
        "&client_uid=" +
        clientUid
    );
    if (typeof response.data === "string") {
      yield put({ type: SET_API_ERROR, payload: true });
    }
    yield put({ type: FETCH_CLIENT_CONTRACTS_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_DATA_ERROR, payload: error });
  }
}

export function* getContractStatuses(id, objectId, locationId, regionId, clientUid, date) {
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "clients/contract_statuses" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date +
        "" +
        "&client_uid=" +
        clientUid
    );
    if (typeof response.data === "string") {
      yield put({ type: SET_API_ERROR, payload: true });
    }
    yield put({ type: FETCH_CONTRACTS_STATUSES_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_DATA_ERROR, payload: error });
  }
}

export function* getContractFreezes(id, objectId, locationId, regionId, clientUid, date) {
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "clients/contract_freezes" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date +
        "" +
        "&client_uid=" +
        clientUid
    );
    if (typeof response.data === "string") {
      yield put({ type: SET_API_ERROR, payload: true });
    }
    yield put({ type: FETCH_CONTRACTS_FREEZES_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_DATA_ERROR, payload: error });
  }
}

export function* getClientContactLogs(id, objectId, locationId, regionId, clientUid, date) {
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "contact_logs" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date +
        "" +
        "&client_uid=" +
        clientUid
    );
    if (typeof response.data === "string") {
      yield put({ type: SET_API_ERROR, payload: true });
    }
    yield put({ type: FETCH_CLIENT_CONTACT_LOGS_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_DATA_ERROR, payload: error });
  }
}

export function* getClientCharts(id, objectId, locationId, regionId, clientUid, date) {
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "clients/charts_info" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date +
        "" +
        "&client_uid=" +
        clientUid
    );
    if (typeof response.data === "string") {
      yield put({ type: SET_API_ERROR, payload: true });
    }
    yield put({ type: FETCH_CLIENT_CHARTS_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_DATA_ERROR, payload: error });
  }
}
